import React from 'react';
import { Button } from '../ui/button';
import { Sparkles, CheckCircle } from 'lucide-react';
import CalendlyPopup from '../CalendlyPopup';
import { useCalendlyAndVideo } from '../../hooks/useCalendlyAndVideo';

const TemplatesHero = () => {
  const { isCalendlyOpen, openCalendly, closeCalendly } = useCalendlyAndVideo();

  const benefits = [
    'AI-powered customization',
    'Ready to use in minutes',
    'Proven by 1000+ teams'
  ];

  return (
    <section className="pt-32 pb-20 px-6 bg-gradient-to-b from-gray-900 to-gray-950">
      <div className="max-w-6xl mx-auto text-center">
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
          Build your playbook with
          <br />
          <span className="text-cyan-400">ready-to-use templates</span>
        </h1>
        
        <p className="text-xl text-gray-300 mb-10 max-w-3xl mx-auto">
          Choose from hundreds of AI training and roleplay scenario templates. Customize them for your team and start building faster.
        </p>

        {/* Benefits */}
        <div className="flex flex-wrap items-center justify-center gap-6 mb-10">
          {benefits.map((benefit, index) => (
            <div key={index} className="flex items-center gap-2">
              <CheckCircle className="w-5 h-5 text-green-400" />
              <span className="text-gray-300">{benefit}</span>
            </div>
          ))}
        </div>

        <Button
          size="lg"
          onClick={openCalendly}
          className="bg-cyan-500 hover:bg-cyan-400 text-black text-lg px-8 py-6 font-semibold"
        >
          Schedule a Discovery Call
        </Button>
      </div>
      
      <CalendlyPopup isOpen={isCalendlyOpen} onClose={closeCalendly} />
    </section>
  );
};

export default TemplatesHero;
